import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'projul-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {
  message: string;
  answer: boolean = false;
  constructor(public bsModalRef: BsModalRef,
  ) { }

  ngOnInit(): void {
  }

  respond(answer: boolean) {
    this.answer = answer;
    this.bsModalRef.hide();
  }

}
